import React from 'react'
import logo from '../../Assets/logoFoot.png'
import TypeAnimation from 'react-type-animation';
import styles from './style.module.scss'

function Loader() {
  return (
      <div className={styles.container} >
        <div className={styles.loadingContainer}>
          <div className={styles.loading}>
            <div className={styles.spinner}>
              <div className={styles.logoLoading}>
                <img src={logo} alt='Loading...' />
              </div>
            </div>
        </div>
        <div className={styles.text}>
          <TypeAnimation 
            cursor={false}
            sequence={['Loading...', 500]}
            wrapper="h4"
            repeat='Infinity'
          />
        </div>
        </div>
      </div>
  )
}

export default Loader;